export type LupaRiskSortBy =
  | 'clinic_name'
  | 'patient_first_name'
  | 'patient_last_name'
  | 'mrn'
  | 'episode_start_date'
  | 'episode_end_date'
  | 'period_1_status'
  | 'period_1_lupa_threshold'
  | 'period_1_billable_visit_count'
  | 'period_1_difference'
  | 'period_2_status'
  | 'period_2_lupa_threshold'
  | 'period_2_billable_visit_count'
  | 'period_2_difference'
  | 'primary_difference'
  | 'risk_status';

/**
 * Array of all LupaRiskSortBy values.
 */
export const LUPARISKSORTBY_VALUES: readonly LupaRiskSortBy[] = [
  'clinic_name',
  'patient_first_name',
  'patient_last_name',
  'mrn',
  'episode_start_date',
  'episode_end_date',
  'period_1_status',
  'period_1_lupa_threshold',
  'period_1_billable_visit_count',
  'period_1_difference',
  'period_2_status',
  'period_2_lupa_threshold',
  'period_2_billable_visit_count',
  'period_2_difference',
  'primary_difference',
  'risk_status',
] as const;
